import React from 'react'
import {Form} from 'react-bootstrap'

// Dropdown styled like the site's SelectInput, for options whose label differs from their
// value (a model listed by its short name but kept by its full one; "2.25 D (T4)" kept as
// 2.25). SelectInput shows each value as its own label, and is shared with the other
// calculators, so it is left as it is.
// options: [{value, label}]. Until one is picked, the placeholder shows and VS keeps
// whatever it holds - the form decides what that means. Picking one sets [value, 1].
export default function OptionSelect({label, VS, setVS, placeholder, options}) {

    const chosen = options.some((option) => option.value === VS[0]);

    return (
        <Form onSubmit={e => { e.preventDefault(); }}>
            <Form.Group>
                <div className='inputDiv'>
                    <span className='controlLabel'
                    style={{display: (label === '')? 'none' : null}}>
                        {label}&nbsp;
                    </span>
                    <Form.Select
                    className={((chosen)? 'formControl controlValid eyeInput' : 'formControl controlNeutral') + ' noPadding'}
                    value={(chosen)? VS[0] : ''}
                    onChange={(e) => setVS([e.target.value, 1])}>
                        <option value='' style={{display: 'none'}}>{placeholder}</option>
                        {options.map((option) =>
                            <option key={option.value} value={option.value}>{option.label}</option>
                        )}
                    </Form.Select>
                </div>
            </Form.Group>
        </Form>
    )
}
